import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { env } from "configs/EnvironmentConfig";

const URL_GRUPO_LIVE = "https://chat.whatsapp.com/Bx35xB04YPo3rBriUpa5u1";

/**
 * Componente que redireciona para o grupo da Live no WhatsApp
 * Registra o clique antes de redirecionar
 * 
 * URL: /grupo-live/:idUsuario
 */
const GrupoLiveRedirect = () => {
	const { idUsuario } = useParams();

	useEffect(() => {
		const registrarERedirecionarAsync = async () => {
			try {
				// Tentar registrar o clique
				await fetch(`${env.API_ENDPOINT_URL}/v1/rpc/registrar-clique`, {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						identificador_link: "grupo-live",
						id_usuario: idUsuario ? parseInt(idUsuario) : null,
						url_destino: URL_GRUPO_LIVE,
					}),
				});
			} catch (error) {
				// Ignora erros - não deve bloquear o redirecionamento
				console.log("Erro ao registrar clique (ignorado):", error);
			}

			// Redireciona para o grupo
			window.location.href = URL_GRUPO_LIVE;
		};

		registrarERedirecionarAsync();
	}, [idUsuario]);

	// Mostra uma mensagem enquanto redireciona
	return (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				fontFamily: "sans-serif",
				flexDirection: "column",
				gap: "16px",
			}}
		>
			<div
				style={{
					width: "40px",
					height: "40px",
					border: "4px solid #f3f3f3",
					borderTop: "4px solid #25D366",
					borderRadius: "50%",
					animation: "spin 1s linear infinite",
				}}
			/>
			<p>Redirecionando para o grupo da live...</p>
			<style>
				{`
					@keyframes spin {
						0% { transform: rotate(0deg); }
						100% { transform: rotate(360deg); }
					}
				`}
			</style>
		</div>
	);
};

export default GrupoLiveRedirect;
